import React, { useEffect, useState } from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  useEffect(() => {
    if (!quickViewProduct) return undefined;
    const closeOnEscape = (event) => event.key === "Escape" && setQuickViewProduct(null);
    document.addEventListener("keydown", closeOnEscape);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.style.overflow = "";
    };
  }, [quickViewProduct]);

  return (
    <div className="shop main">
      <div className="shop-grid">
        {productData.map((product) => (
          <article className="product-card" key={product.id}>
            <div className="image-container">
              <Link to={`/shopDetails/${product.id}`} onClick={toTop} className="product-image-link" aria-label={`View ${product.name} details`}>
                <img src={product.image} alt={product.name} />
              </Link>
              <div className="hover-content">
                <h3 className="product-name">{product.name.toLowerCase()}</h3>
                <p className="product-price">${product.price}</p>
                <button className="quick-view" type="button" onClick={() => setQuickViewProduct(product)}>QUICK VIEW</button>
              </div>
            </div>
          </article>
        ))}
      </div>

      {quickViewProduct && (
        <div className="quick-view-overlay" role="presentation" onMouseDown={(event) => {
          if (event.target === event.currentTarget) setQuickViewProduct(null);
        }}>
          <section className="quick-view-modal" role="dialog" aria-modal="true" aria-labelledby="quick-view-title">
            <button className="quick-view-close" type="button" aria-label="Close quick view" onClick={() => setQuickViewProduct(null)}>×</button>
            <div className="quick-view-image"><img src={quickViewProduct.image} alt={quickViewProduct.name} /></div>
            <div className="quick-view-details">
              <p className="quick-view-category">{quickViewProduct.category}</p>
              <h2 id="quick-view-title">{quickViewProduct.name}</h2>
              <p className="quick-view-price">${quickViewProduct.price}</p>
              <p>{quickViewProduct.description[0]}</p>
              <p className="quick-view-material">{quickViewProduct.material}</p>
              <Link to={`/shopDetails/${quickViewProduct.id}`} onClick={toTop} className="quick-view-detail-link">VIEW FULL DETAILS</Link>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default Shop;
